import React from "react";
import { useFSmallCreditCard } from "./hooks/useFSmallCreditCard";
import styles from "./style/FSmallCreditCard.module.scss";
/* This example requires Tailwind CSS v2.0+ */
import { ChevronRightIcon } from "@heroicons/react/solid";
import { deleteCardById } from "../../api/cards";
import { Trash } from "react-ionicons";

const deleteCard = async (cardId) => {
  let resp = await deleteCardById(cardId);
  if (resp.status != 200) {
    //console.log(resp.data)
    return false;
  }
  window.location.reload();
};

const FSmallCreditCard = ({ arrayGroups = [], onChange = () => { },onDeleteEmail = () => { } }) => {
  return (
    <div>
      <ul role="list" className="mt-3 grid grid-cols-1 gap-5 lg:grid-cols-1">
        {arrayGroups.map((group) => (
          <li
            key={group.name}
            className="border-2 h-[170px] col-span-1 flex shadow-md rounded-xl cursor-pointer"
            style={{
              backgroundImage: `linear-gradient(to right,${group.mii === "VISA"
                ? "#41295a,#2F0743"
                : group.mii === "MASTERCARD"
                  ? "#23074d,#cc5333"
                  : group.mii === "AMERICAN_EXPRESS"
                    ? "#000428,#004e92"
                    : "#232526,#414345"
                } )`,
            }}
            onClick={() => {
              onChange(group);
            }}
          >
            <div className="grid grid-cols-12 border-0 w-screen gap-3 text-white">
              <div className="col-span-12 border-0 border-white flex items-center place-content-start pl-6 pt-3">
                <div className="border-0 w-full grid grid-cols-2">
                  <div className="col-span-1">
                    <img
                      src={
                        group.mii === "VISA"
                          ? require("../../components/assets/images/visa.png")
                          : group.mii === "MASTERCARD"
                            ? require("../../components/assets/images/mastercard.png")
                            : group.mii === "AMERICAN_EXPRESS"
                              ? require("../../components/assets/images/american-express.png")
                              : require("../../components/assets/images/other.png")
                      }
                      className="w-10 border-0"
                      alt=""
                    />
                  </div>
                  <div className="col-span-1  grid items-center justify-end pr-5">
                    <Trash
                      color={"white"}
                      height="27px" width="27px"
                      onClick={() => {
                        onDeleteEmail(group);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-span-6 border-0 flex items-center place-content-start pl-6 pb-4 font-semibold text-[14px]">
                {group.cardHolder.name}
              </div>
              <div className="col-span-6 border-0 flex items-center place-content-end pr-4 pb-4 font-bold text-[16px]">
                **** {group.panLastDigits}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FSmallCreditCard;
